export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/menu-qr-new-aed00d92be8d650024b8d1e9aa05c472.jpg";